<configuration-option-main-branding
  [isCollapsed]="false"
  [formValues]="configFormValues$ | async"
  (onSubmit)="onSubmit($event)"
></configuration-option-main-branding>

<configuration-option-branding-settings
  *ngIf="moduleConfigs.configOptionModule.customStyleSettings"
  [isCollapsed]="true"
  [formValues]="configFormValues$ | async"
  [isloadingFromParentPage]="isLoading$ | async"
  (onSubmit)="onSubmit($event)"
>
</configuration-option-branding-settings>
